module.exports = __webpack_public_path__ + "media/signup-react/coffe-bbd97375.png";